import { api } from "../common/http";

const toPage = (res) => res.data;

function buildAuditParams({
  page = 0,
  size = 20,
  sort = "occurredAt,desc",
  q,
  action,
  entityType,
  entityId,
  success,         
  errorCode,
  businessId,      
  from,            
  to,              
  actorRoles,      
} = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  if (action) params.action = action;
  if (entityType) params.entityType = entityType;
  if (entityId) params.entityId = entityId;
  if (success !== undefined) params.success = success;
  if (errorCode) params.errorCode = errorCode;
  if (businessId !== undefined && businessId !== null) params.businessId = businessId;
  if (from) params.from = from;
  if (to) params.to = to;

  params.__actorRoles = Array.isArray(actorRoles) ? actorRoles.filter(Boolean) : [];

  return params;
}


function auditParamsSerializer(params) {
  const sp = new URLSearchParams();

  Object.entries(params).forEach(([k, v]) => {
    if (k === "__actorRoles") return; 
    if (v === undefined || v === null) return;
    sp.append(k, String(v));
  });

  if (Array.isArray(params.__actorRoles) && params.__actorRoles.length) {
    params.__actorRoles.forEach((role) => sp.append("actorRoles", role));
  }

  return sp.toString();
}

const AuditLogApi = {
  
  list: async (opts = {}) => {
    const params = buildAuditParams(opts);
    const res = await api.get("/admin/audit-logs", {
      params,
      paramsSerializer: auditParamsSerializer,
    });
    return toPage(res); 
  },

  summary: async (opts = {}) => {
    const params = buildAuditParams(opts);
    const res = await api.get("/admin/audit-logs/summary", {
      params,
      paramsSerializer: auditParamsSerializer,
    });
    return res.data;
  },

  getById: async (id) => (await api.get(`/admin/audit-logs/${id}`)).data,

  delete: async (id) => (await api.delete(`/admin/audit-logs/${id}`)).data,

  deleteRange: async ({ from, to }) =>
    (await api.post("/admin/audit-logs/delete-range", { from, to })).data,

};

export default AuditLogApi;
